var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.propertyGroup.group
    ? _c(
        "div",
        {
          staticClass: "bg-lightblue px-2 py-2",
          class: _vm.paddingClasses,
          style: _vm.paddingInlineStyles,
        },
        [
          _c("div", {
            staticClass: "h4",
            domProps: { innerHTML: _vm._s(_vm.propertyGroup.group.names.name) },
          }),
          _vm._v(" "),
          _c("div", { staticClass: "position-relative" }, [
            _c("div", [
              _c("div", { staticClass: "input-unit order-property-input" }, [
                _c(
                  "select",
                  {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.selectionValue,
                        expression: "selectionValue",
                      },
                    ],
                    staticClass: "custom-select p-3",
                    on: {
                      change: [
                        function ($event) {
                          var $$selectedVal = Array.prototype.filter
                            .call($event.target.options, function (o) {
                              return o.selected
                            })
                            .map(function (o) {
                              var val = "_value" in o ? o._value : o.value
                              return val
                            })
                          _vm.selectionValue = $event.target.multiple
                            ? $$selectedVal
                            : $$selectedVal[0]
                        },
                        function ($event) {
                          return _vm.onInputValueChanged()
                        },
                      ],
                    },
                  },
                  [
                    _vm._l(_vm.propertyGroup.properties, function (property) {
                      return [
                        _c(
                          "option",
                          {
                            key: property.id,
                            domProps: { value: property.id },
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(property.names.name) +
                                "\n                "
                            ),
                            _vm.surcharge(property) > 0
                              ? [
                                  _vm._v(
                                    "\n                  (+ " +
                                      _vm._s(
                                        _vm._f("currency")(
                                          _vm.surcharge(property)
                                        )
                                      ) +
                                      ")\n                "
                                  ),
                                ]
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]
                    }),
                  ],
                  2
                ),
              ]),
            ]),
          ]),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }